import * as React from 'react';
import { Text } from '@grandvisionhq/elements';
import { Spinner } from '@grandvisionhq/iris-ui';

const AppointmentPickDifferentTimeSlotLoading = ({ labels  })=>/*#__PURE__*/ React.createElement("div", {
        className: "appointment-pick-different-time-slot__loading"
    }, /*#__PURE__*/ React.createElement(Spinner, {
        className: "appointment-pick-different-time-slot__loader"
    }), /*#__PURE__*/ React.createElement(Text, null, labels.loading))
;

export { AppointmentPickDifferentTimeSlotLoading as default };
//# sourceMappingURL=AppointmentPickDifferentTimeSlotLoading.js.map
